var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg1Yellow = function Svg1Yellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-yellow-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.139 23.797V35h-1.852v-8.625l-2.53 2.047v-2.25l3.1-2.375h1.282Z",
    fill: "#fff"
  })));
};

export default Svg1Yellow;